var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600", "retain-focus": false, persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("v-card", { staticClass: "primary p-4" }, [
        _c(
          "div",
          {
            staticClass:
              " navy--text text--darken-1 pt-2 px-2 d-flex align-center font-hemi-head",
          },
          [
            _c("v-icon", { staticClass: "white--text", attrs: { left: "" } }, [
              _vm._v("design_services"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "white--text",
                staticStyle: { "font-size": "18px" },
              },
              [_vm._v("PIANIFICAZIONE ROSA")]
            ),
            _vm._v(" "),
            _c("v-spacer"),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { depressed: "", icon: "" },
                on: {
                  click: function ($event) {
                    return _vm.dismiss()
                  },
                },
              },
              [_c("v-icon", [_vm._v("close")])],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navy darken-1 white--text pa-4" },
          [
            _c(
              "v-alert",
              {
                staticClass: "mb-4",
                attrs: { dense: "", text: "", type: "info" },
              },
              [
                _vm._v(
                  "\n          Puoi usare Asta Live ignorando la 'Pianificazione Rosa'."
                ),
                _c("br"),
                _vm._v(
                  "\n          Tuttavia ti incoragggiamo fortemente a usarla perché ti aiuta a non fare pazzie durante le concitate fasi d'asta e rimanere equilibrato.\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.mantra
              ? _c(
                  "div",
                  [
                    _c(
                      "v-alert",
                      { attrs: { dense: "", text: "", type: "info" } },
                      [
                        _vm._v(
                          "\n          Sebbene sia una lega a Mantra, per la\n          pianificazione dei ruoli da acquistare si fa riferimento ai ruoli\n          "
                        ),
                        _c("b", [_vm._v("classici")]),
                        _vm._v(
                          " (identificabili dal bordo sinistro del rettangolo\n          intorno al calciatore)\n             "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.asta_info.lega.nRuoli.op == "illimitati"
              ? _c("div", { staticClass: "d-flex flex-column pt-4" }, [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "text-uppercase font-weight-bold mb-2" },
                      [_vm._v("\n            Numero calciatori\n          ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-2" }, [
                      _vm._v(
                        'In questa lega ci sono acquisti "illimitati / a piacere". Per poter\n          procedere a una pianificazione devi innanzitutto impostare quanti\n          calciatori intendi acquistare per ciascun ruolo'
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nP_items.includes(_vm.nP) },
                        attrs: {
                          items: _vm.nP_items,
                          label: "P",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nP,
                          callback: function ($$v) {
                            _vm.nP = $$v
                          },
                          expression: "nP",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nD_items.includes(_vm.nD) },
                        attrs: {
                          items: _vm.nD_items,
                          label: "D",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nD,
                          callback: function ($$v) {
                            _vm.nD = $$v
                          },
                          expression: "nD",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nC_items.includes(_vm.nC) },
                        attrs: {
                          items: _vm.nC_items,
                          label: "C",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nC,
                          callback: function ($$v) {
                            _vm.nC = $$v
                          },
                          expression: "nC",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nA_items.includes(_vm.nA) },
                        attrs: {
                          items: _vm.nA_items,
                          label: "A",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nA,
                          callback: function ($$v) {
                            _vm.nA = $$v
                          },
                          expression: "nA",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column pt-4" }, [
              _c(
                "div",
                { staticClass: "text-uppercase font-weight-bold mb-2" },
                [_vm._v("\n            1. Pianifica crediti slot\n          ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _vm._v(
                  "Hai 2 modi per pianificare i crediti da spendere per ogni slot:"
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("chevron_right"),
                  ]),
                  _vm._v(' Manualmente cliccando su "..."'),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("chevron_right"),
                  ]),
                  _vm._v("\n           Automaticamente "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-1 font-weight-bold",
                      attrs: {
                        outlined: "",
                        "x-small": "",
                        color: "secondary",
                      },
                      on: { click: _vm.promptStrategia },
                    },
                    [_vm._v("\n            cliccando qui\n          ")]
                  ),
                  _vm._v(
                    ". Tranquillo, potrai sempre modificarli singolarmente dopo."
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column pt-4" }, [
              _c(
                "div",
                { staticClass: "text-uppercase font-weight-bold mb-2" },
                [
                  _vm._v(
                    '\n            2. Pianifica "Calciatori Obiettivi" slot (opzionale)\n          '
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _vm._v(
                  'Opzionalmente puoi aggiungere i calciatori obiettivo (quelli che vorresti acquistare)\n            per ogni slot: nella tabella precedente clicca su "Aggiungi Obiettivo". Puoi aggiungere piú obiettivi per ciascun slot. '
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column pt-4" }, [
              _c(
                "div",
                { staticClass: "text-uppercase font-weight-bold mb-2" },
                [_vm._v("\n            Et voilá.\n          ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _vm._v(
                  "\n            Durante l'asta man mano che acquisti calciatori:\n             "
                ),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                  Asta Live inserisce in automatico il calciatore comprato\n                  nello slot adeguato (sostituendo i crediti pianificati con\n                  quelli effettivamente spesi)\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                  Se hai speso di più o di meno di quanto pianificato per\n                  quello slot, "
                    ),
                    _c("b", { staticClass: "accent--text" }, [
                      _vm._v(
                        "Asta Live ti avvisa quanti crediti devi\n                  ridistribuire tra gli slot liberi rimanenti"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                  Rimuove automaticamente dalla tua lista gli obiettivi non\n                  più disponibili\n                "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "v-expansion-panels",
              { staticClass: "mb-4", attrs: { flat: "" } },
              [
                _c(
                  "v-expansion-panel",
                  [
                    _c(
                      "v-expansion-panel-header",
                      {
                        staticClass: "font-hemi-head",
                        scopedSlots: _vm._u([
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c("v-icon", { staticClass: "text--white" }, [
                                  _vm._v("fa-caret-down "),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _vm._v(
                          "\n            FAQ / Domande frequenti\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-expansion-panel-content", [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [
                            _c("b", [
                              _vm._v(
                                "E' obbligatorio usare la Pianificazione?"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                No. Puoi usare Asta Live ignorando completamemte la pianificazione\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [
                            _c("b", [
                              _vm._v(
                                "Perchè sono scomparsi dei calciatori dalla mia lista\n                  obiettivi?"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                Perchè non sono più disponibili tra gli svincolati: o sono\n                stati acquistati (da qualcun altro o da te), o sono stati\n                scartati, o non giocano più nel campionato\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [
                            _c("b", [
                              _vm._v(
                                "Con che logica Asta Live sceglie in quale slot inserire il\n                  calciatore appena acquistato?"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            '\n                - Quando acquisti un calciatore presente nella "Lista Obiettivi", Asta Live lo inserisce automaticamente nel relativo slot.'
                          ),
                          _c("br"),
                          _vm._v(
                            '\n                - Quando invece acquisti un calciatore che non hai messo nella "Lista Obiettivi",\n                Asta Live lo inserisce nello slot libero in cui i crediti spesi sono il più possibile simili a quelli pianificati.\n                Se non hai pianificato crediti per quel ruolo, usa il primo slot libero.\n              '
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [
                            _c("b", [
                              _vm._v(
                                "Asta Live mi ha inserito un calciatore acquistato in un\n                  certo slot ma io vorrei inserirlo in un altro"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            '\n                Non c\'è problema. Puoi toglierlo dallo slot (premendo sulla "x")\n                e poi inserirlo in un altro slot (premendo sul "+" che comparirá)\n              '
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }